export default __webpack_public_path__ + "static/133-aeec8d3a6bd0a4378d4ee6cc04b61f3d.jpg";